<template>
  <div id='related-posts'>
    <!-- Skeleton screen -->
    <template v-if="state.loading">
      <div class="post-item" v-for="i in 6" :key="'skeleton-'+i">
        <div class="block w-full relative">
          <div class="aspect-square bg-[#181C1F] rounded-lg relative">
            <div class="absolute bottom-2 left-2 bg-gray-800 h-4 w-16 rounded"></div>
          </div>
        </div>
      </div>
    </template>
    <template v-else-if="state.relatedPosts.length > 0" v-for="(post, index) in state.relatedPosts" :key="post.id">
      <post-item
        :post="post"
        :hidden_creator="true"
        :list-name="'related_posts:' + state.post_id"
        :ref="(el) => bindImpression(post.id, el ? el.$el : null, relatedModelPayload(post, index))"
        @click="trackRelatedModelClick(post, index)"
      ></post-item>
    </template>
  </div>
</template>
<script>
import { defineComponent } from "vue";
import { state } from "../stores/postState";
import { useModuleImpression } from "../utils/useModuleImpression";

export default defineComponent({
  setup() {
    const { bindImpression } = useModuleImpression()
    return { bindImpression }
  },
  data() {
    return {
      state
    };
  },
  mounted() {
    this.state.post_id = window.location.href.match(/\/posts\/(\d+)/)[1]
    this.state.relatedPosts = []
    this.state.loading = false

    this.getRelatedPosts()
  },
  methods: {
    relatedModelPayload(post, index) {
      return {
        page_type: 'post',
        module: 'related_models',
        landing_path: window.location.pathname,
        target_type: 'post',
        target_id: post.id,
        position: index,
      };
    },
    trackRelatedModelClick(post, index) {
      if (!window.trackingEvent) return;

      window.trackingEvent.track_module_click(this.relatedModelPayload(post, index));
    },
    async getRelatedPosts(){
      if (this.state.loading) return;

      this.state.loading = true

      try {
        const api_path = '/api/v1/posts/' + this.state.post_id + '/related_posts'
        const response = await fetch(api_path);

        if (response.ok) {
          const data = await response.json();
          const postsData = data['data']
          this.state.relatedPosts = postsData;

          // GA4: view_item_list for related posts
          if (window.trackingEvent && postsData.length > 0) {
            window.trackingEvent.view_item_list({
              item_list_id: 'related_posts:' + this.state.post_id,
              item_list_name: 'related_posts',
              item_list_index: 1,
              items: postsData.map((item, index) => ({
                id: item.id,
                title: item.title,
                creator: item.creator?.brand_name,
                price: item.price,
                index,
              }))
            })
          }
        }
      } catch (error) {
        this.state.relatedPosts = []
      } finally {
        this.state.loading = false
      }
    }
  }
});
</script>
